<template>
	<div class="card md-elevation-4">
		<div style="padding: 10px; display: flex">
			<el-tooltip>
				<div slot="content">
					<span>{{ $t("subscriptions-overview-content") }}</span>
				</div>
				<span style="margin-top: auto; margin-bottom: auto" class="title">{{
					$t("subscriptions-overview")
				}}</span>
			</el-tooltip>
		</div>
		<div style="display: flex">
			<div style="width: 100%">
				<apexchart
					:key="refresh"
					type="bar"
					height="350"
					ref="bar_charts"
					:options="barOptions"
					:series="barSeries"
				></apexchart>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
export default {
	name: "subscriptions-chart",
	data() {
		return {
			refresh: 0,

			selected: undefined,
			status: [this.$t("active"), this.$t("inactive")],
			active_status: [this.$t("active"), this.$t("visible"), this.$t("invisible")],

			// BAR CHART
			barOptions: {
				chart: {
					type: "bar",
					height: 350
				},
				plotOptions: {
					bar: {
						dataLabels: {
							position: "top"
						}
					}
				},
				dataLabels: {
					enabled: true,
					offsetX: -6,
					style: {
						fontSize: "12px",
						colors: ["#fff"]
					}
				},
				stroke: {
					show: true,
					width: 2,
					colors: ["#fff"]
				},

				xaxis: {
					categories: []
				}
			},
			barSeries: [],

			// PIE CHART
			series: [0, 0]
		}
	},
	computed: {
		...mapGetters({
			categorizedSubscriptions: "dashboard/categorizedSubscriptions"
		})
	},
	watch: {
		categorizedSubscriptions: function () {
			var legends = []
			var series = []

			for (const [key, value] of Object.entries(this.categorizedSubscriptions)) {
				if (key != "prova gratuita" && value != 0) {
					legends.push(key)
					series.push(value)
				}
			}

			this.barSeries = [{ name: "", data: series }]
			this.barOptions.xaxis.categories = legends
			this.refresh++
		}
	},
	methods: {
		...mapActions({
			doCategorizedSubscriptions: "dashboard/doCategorizedSubscriptions"
		})
	},
	created() {
		this.doCategorizedSubscriptions()
	}
}
</script>

<style scoped lang="scss">
.card {
	height: auto;
	margin: 5px;
	.title {
		font-size: 24px;
		font-weight: 900;
		&:hover {
			cursor: pointer;
		}
	}
}
.test {
	padding: 20px;
}
span {
	font-family: "Montserrat", sans-serif;
}
</style>
